import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 700 600", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 700, height: 600, fill: "#0DB02B" }), /* @__PURE__ */ React.createElement("rect", { width: 700, height: 400, fill: "#FFF" }), /* @__PURE__ */ React.createElement("rect", { width: 700, height: 200, fill: "#e05206" }), /* @__PURE__ */ React.createElement("circle", { cx: 350, cy: 300, r: 85, fill: "#e05206" }));
const ForwardRef = forwardRef(SvgNe);
const Memo = memo(ForwardRef);
export default Memo;
